(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[462],{

/***/ 6253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_ArticleItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9980);
/* harmony import */ var _ArticleGrid_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2768);
/* harmony import */ var _ArticleGrid_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ArticleGrid_module_css__WEBPACK_IMPORTED_MODULE_3__);






function ArticleGrid(param) {
    var articles = param.articles, className = param.className, articleClassName = param.articleClassName;
    if ((articles === null || articles === void 0 ? void 0 : articles.length) < 1) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ArticleGrid_module_css__WEBPACK_IMPORTED_MODULE_3___default().container), className, "articleGrid"),
        children: articles.map(function(p) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ArticleItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ArticleGrid_module_css__WEBPACK_IMPORTED_MODULE_3___default().article), articleClassName)
            }, p), p.id);
        })
    });
}
ArticleGrid.propTypes = {
    articles: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().array),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    articleClassName: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
ArticleGrid.defaultProps = {
    articles: [],
    className: "",
    articleClassName: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleGrid);


/***/ }),

/***/ 9980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5641);
/* harmony import */ var components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2657);
/* harmony import */ var _ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2563);
/* harmony import */ var _ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_formatDate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1588);







function ArticleItem(param) {
    var title = param.title, slug = param.slug, date = param.date, acfPost = param.acfPost, acfPostSettings = param.acfPostSettings, feature = param.feature, landscapeImg = param.landscapeImg, className = param.className;
    var img = acfPost === null || acfPost === void 0 ? void 0 : acfPost.featuredImage;
    var imgUrl = img === null || img === void 0 ? void 0 : img.mediaItemUrl;
    var categories = acfPostSettings === null || acfPostSettings === void 0 ? void 0 : acfPostSettings.globalCategoriesTag;
    var relatedModels = acfPostSettings.relatedModels;
    var setImgSize = function() {
        var mobile = "w_514";
        var desktop = "w_270";
        if (feature) {
            mobile = "w_656";
            desktop = "w_853";
        } else if (landscapeImg) {
            mobile = "w_656";
            desktop = "w_656";
        }
        return {
            mobile: mobile,
            desktop: desktop
        };
    };
    // TODO: at the very tail end of the project it was asked to split titles by pipe.
    // This is used in <ArticlesRelated/> so you can make a component to unify this.
    var setRelatedModels = relatedModels === null || relatedModels === void 0 ? void 0 : relatedModels.map(function(rm) {
        return rm.title;
    }).join(", ").replace(/,(?!.*,)/gim, " &");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4___default().container), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                type: "Article",
                href: slug,
                className: (_ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4___default().link),
                children: [
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: (_ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4___default().img),
                        images: [
                            {
                                url: imgUrl,
                                params: "".concat(setImgSize().mobile, ",f_auto")
                            },
                            {
                                url: imgUrl,
                                params: "".concat(setImgSize().desktop, ",f_auto")
                            }, 
                        ]
                    }),
                    relatedModels && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: (_ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4___default().title),
                        dangerouslySetInnerHTML: {
                            __html: setRelatedModels
                        }
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: (_ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                        dangerouslySetInnerHTML: {
                            __html: title.substr(0, title.lastIndexOf("|")) || title
                        }
                    }),
                    date && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4___default().created),
                        children: (0,_helpers_formatDate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Date(date))
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4___default().tags),
                children: categories === null || categories === void 0 ? void 0 : categories.slice(0, 3).map(function(param) {
                    var name = param.name, slug = param.slug;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        type: "Category",
                        href: slug,
                        className: (_ArticleItem_module_css__WEBPACK_IMPORTED_MODULE_4___default().tag),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: name
                            }
                        })
                    }, slug);
                })
            })
        ]
    });
}
ArticleItem.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    slug: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    date: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    acfPost: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    acfPostSettings: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    feature: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
ArticleItem.defaultProps = {
    title: "",
    slug: "",
    date: "",
    acfPost: {},
    acfPostSettings: {},
    feature: false,
    className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleItem);


/***/ }),

/***/ 7879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var context_SitesContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9563);
/* harmony import */ var _BackButton_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6749);
/* harmony import */ var _BackButton_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BackButton_module_css__WEBPACK_IMPORTED_MODULE_5__);







function BackButton(param) {
    var fallback = param.fallback, className = param.className;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var currentSite = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_SitesContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .SitesContext */ .y).currentSite;
    var handleClick = function() {
        router.back();
    // todo: ideally we could use the 'fallback' prop to navigate to if we don't
    // have a 'back' state (i.e. new tab directly to URL)
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_BackButton_module_css__WEBPACK_IMPORTED_MODULE_5___default().container), className),
        onClick: handleClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_BackButton_module_css__WEBPACK_IMPORTED_MODULE_5___default().btn)
        })
    });
}
BackButton.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    fallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
BackButton.defaultProps = {
    className: "",
    fallback: null
};
/* harmony default export */ __webpack_exports__["Z"] = (BackButton);


/***/ }),

/***/ 2657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CloudinaryMedia; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/CloudinaryMedia/CloudinaryVideo/CloudinaryVideo.module.css
var CloudinaryVideo_module = __webpack_require__(3725);
var CloudinaryVideo_module_default = /*#__PURE__*/__webpack_require__.n(CloudinaryVideo_module);
;// CONCATENATED MODULE: ./components/CloudinaryMedia/CloudinaryVideo/index.js





// import cloudinaryUrl from 'helpers/cloudinaryUrl'

// NOTE: Cloudinary is becoming too expensive to use for the client.
// With so much media and primarily the bandwidth being too high we have to remove
// video assets being served for now.
function CloudinaryVideo(param) {
    var videos = param.videos, videoAutoplay = param.videoAutoplay, videoLoop = param.videoLoop, videoEnded = param.videoEnded, className = param.className;
    if ((videos === null || videos === void 0 ? void 0 : videos.length) < 1) return null;
    var ref = (0,react.useState)(false), inProp = ref[0], setInProp = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        className: classnames_default()((CloudinaryVideo_module_default()).container, className, (0,_define_property/* default */.Z)({}, (CloudinaryVideo_module_default()).loaded, inProp === true)),
        playsInline: true,
        autoPlay: videoAutoplay === true,
        muted: true,
        loop: videoLoop,
        // controls
        onEnded: function() {
            return videoEnded();
        },
        onLoadedData: function() {
            return setInProp(true);
        },
        children: videos.map(function(param) {
            var url = param.url, type = param.type;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                src: url,
                type: type
            }, url);
        })
    });
}
CloudinaryVideo.propTypes = {
    videos: prop_types_default().arrayOf(prop_types_default().shape({
        url: (prop_types_default()).string,
        type: (prop_types_default()).string,
        params: (prop_types_default()).string
    })),
    videoAutoplay: (prop_types_default()).bool,
    videoLoop: (prop_types_default()).bool,
    videoEnded: (prop_types_default()).func,
    className: (prop_types_default()).string
};
CloudinaryVideo.defaultProps = {
    videos: [
        {
            url: "",
            type: "",
            params: ""
        }, 
    ],
    videoAutoplay: true,
    videoLoop: false,
    videoEnded: function() {},
    className: ""
};
/* harmony default export */ var CloudinaryMedia_CloudinaryVideo = (CloudinaryVideo);

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(7821);
// EXTERNAL MODULE: ./helpers/isModellinkSite.js
var isModellinkSite = __webpack_require__(2084);
;// CONCATENATED MODULE: ./helpers/cloudinaryUrl.js


function cloudinaryUrl(type, url, params) {
    var trimUrl = url.replace(/https:\/\/cms-dev*\.selectmodel\.com\/([^/]+\/)*wp-content\/uploads\//, "").replace(/https:\/\/cms-new*\.selectmodel\.com\/([^/]+\/)*wp-content\/uploads\//, "").replace(/https:\/\/cms-test*\.selectmodel\.com\/([^/]+\/)*wp-content\/uploads\//, "").replace(/https:\/\/([\w]+\.)?cms\.selectmodel\.com\/([^/]+\/)*wp-content\/uploads\//, "");
    var folder = (0,isModellinkSite/* default */.Z)() ? "wp-modellink" : "wp-select-model";
    var setParams = params ? "/".concat(params) : "";
    return "".concat(constants/* CLOUDINARY_URL */.uA, "/").concat(type, "/upload").concat(setParams, "/").concat(folder, "/").concat(trimUrl);
}

// EXTERNAL MODULE: ./components/CloudinaryMedia/CloudinaryImage/CloudinaryImage.module.css
var CloudinaryImage_module = __webpack_require__(4027);
var CloudinaryImage_module_default = /*#__PURE__*/__webpack_require__.n(CloudinaryImage_module);
;// CONCATENATED MODULE: ./components/CloudinaryMedia/CloudinaryImage/index.js







function CloudinaryImage(param) {
    var images = param.images, className = param.className, alt = param.alt;
    if ((images === null || images === void 0 ? void 0 : images.length) < 1) return null;
    var ref = (0,react.useState)(false), inProp = ref[0], setInProp = ref[1];
    var setImage1 = images[0] || null;
    var setImage2 = images[1] || null;
    var setImage1Params = (setImage1 === null || setImage1 === void 0 ? void 0 : setImage1.params) || null;
    var setImage2Params = (setImage2 === null || setImage2 === void 0 ? void 0 : setImage2.params) || null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        className: classnames_default()((CloudinaryImage_module_default()).container, className, (0,_define_property/* default */.Z)({}, (CloudinaryImage_module_default()).loaded, inProp === true)),
        onLoad: function() {
            return setInProp(true);
        },
        children: [
            (setImage2 === null || setImage2 === void 0 ? void 0 : setImage2.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                srcSet: cloudinaryUrl("image", setImage2.url, setImage2Params),
                media: "(min-width: 900px)"
            }),
            (setImage1 === null || setImage1 === void 0 ? void 0 : setImage1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: cloudinaryUrl("image", setImage1.url, setImage1Params),
                alt: alt || (setImage1 === null || setImage1 === void 0 ? void 0 : setImage1.alt)
            })
        ]
    });
}
CloudinaryImage.propTypes = {
    images: prop_types_default().arrayOf(prop_types_default().shape({
        url: (prop_types_default()).string,
        alt: (prop_types_default()).string,
        params: (prop_types_default()).string
    })),
    className: (prop_types_default()).string,
    alt: (prop_types_default()).string
};
CloudinaryImage.defaultProps = {
    images: [
        {
            url: "",
            alt: "",
            params: ""
        }, 
    ],
    className: "",
    alt: undefined
};
/* harmony default export */ var CloudinaryMedia_CloudinaryImage = (CloudinaryImage);

// EXTERNAL MODULE: ./components/CloudinaryMedia/CloudinaryMedia.module.css
var CloudinaryMedia_module = __webpack_require__(1130);
var CloudinaryMedia_module_default = /*#__PURE__*/__webpack_require__.n(CloudinaryMedia_module);
;// CONCATENATED MODULE: ./components/CloudinaryMedia/index.js







function CloudinaryMedia(param) {
    var videos = param.videos, videoLoop = param.videoLoop, videoEnded = param.videoEnded, videoAutoplay = param.videoAutoplay, images = param.images, noLazy = param.noLazy, className = param.className, altText = param.altText;
    var ref, ref1;
    var media = null;
    if (videos === null || videos === void 0 ? void 0 : (ref = videos[0]) === null || ref === void 0 ? void 0 : ref.url) {
        media = /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryMedia_CloudinaryVideo, {
            videos: videos,
            videoAutoplay: videoAutoplay,
            videoLoop: videoLoop,
            videoEnded: videoEnded
        });
    } else if (images === null || images === void 0 ? void 0 : (ref1 = images[0]) === null || ref1 === void 0 ? void 0 : ref1.url) {
        media = /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryMedia_CloudinaryImage, {
            images: images,
            alt: altText
        });
    }
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((CloudinaryMedia_module_default()).container, className),
        children: media
    });
    return noLazy ? content : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
        offset: 1000,
        once: true,
        children: content
    });
}
CloudinaryMedia.propTypes = {
    videos: prop_types_default().arrayOf(prop_types_default().shape({
        url: (prop_types_default()).string,
        type: (prop_types_default()).string,
        params: (prop_types_default()).string
    })),
    videoAutoplay: (prop_types_default()).bool,
    videoLoop: (prop_types_default()).bool,
    videoEnded: (prop_types_default()).func,
    images: prop_types_default().arrayOf(prop_types_default().shape({
        url: (prop_types_default()).string,
        alt: (prop_types_default()).string,
        params: (prop_types_default()).string
    })),
    noLazy: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    altText: (prop_types_default()).string
};
CloudinaryMedia.defaultProps = {
    videos: [
        {
            url: "",
            type: "",
            params: ""
        }, 
    ],
    videoAutoplay: true,
    videoLoop: false,
    videoEnded: function() {},
    images: [
        {
            url: "",
            alt: "",
            params: ""
        }, 
    ],
    noLazy: false,
    className: "",
    altText: undefined
};
/* harmony default export */ var components_CloudinaryMedia = (CloudinaryMedia);


/***/ }),

/***/ 3825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/detect-browser/es/index.js
var es = __webpack_require__(3631);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/OutdatedBrowser/OutdatedBrowser.module.css
var OutdatedBrowser_module = __webpack_require__(5193);
var OutdatedBrowser_module_default = /*#__PURE__*/__webpack_require__.n(OutdatedBrowser_module);
;// CONCATENATED MODULE: ./components/OutdatedBrowser/index.js




function OutdatedBrowser(param) {
    var visible = param.visible;
    var ref = (0,react.useState)(visible), mounted = ref[0], setMounted = ref[1];
    var handleClick = function() {
        setMounted(false);
    };
    if (!mounted) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (OutdatedBrowser_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (OutdatedBrowser_module_default()).title,
                children: "Your browser is out-of-date!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (OutdatedBrowser_module_default()).text,
                children: "Please update your browser to view this website correctly."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://browser-update.org/update-browser.html",
                target: "_blank",
                rel: "noopener noreferrer",
                className: (OutdatedBrowser_module_default()).link,
                children: "Update my browser"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (OutdatedBrowser_module_default()).btn,
                onClick: handleClick
            })
        ]
    });
}
OutdatedBrowser.propTypes = {
    visible: (prop_types_default()).bool
};
OutdatedBrowser.defaultProps = {
    visible: false
};
/* harmony default export */ var components_OutdatedBrowser = (OutdatedBrowser);

// EXTERNAL MODULE: ./components/Footer/index.js + 1 modules
var Footer = __webpack_require__(6195);
// EXTERNAL MODULE: ./components/Layout/Layout.module.css
var Layout_module = __webpack_require__(1627);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
;// CONCATENATED MODULE: ./components/Layout/index.js







function Layout(param) {
    var children = param.children, footerLess = param.footerLess, className = param.className, globalSettings = param.globalSettings, contentClassName = param.contentClassName;
    var browser = (0,es/* detect */.qY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OutdatedBrowser, {
                visible: browser && browser.name === "ie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "layout",
                className: classnames_default()((Layout_module_default()).main, contentClassName),
                children: children
            }),
            !footerLess && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                globalSettings: globalSettings
            })
        ]
    });
}
Layout.propTypes = {
    className: (prop_types_default()).string,
    footerLess: (prop_types_default()).bool,
    globalSettings: (prop_types_default()).object,
    contentClassName: (prop_types_default()).string
};
Layout.defaultProps = {
    footerLess: false,
    className: "",
    globalSettings: {},
    contentClassName: ""
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 9753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(260);
/* harmony import */ var context_SitesContextProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9563);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7821);
/* harmony import */ var hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(662);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5641);
/* harmony import */ var components_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1382);
/* harmony import */ var components_BackButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7879);
/* harmony import */ var _NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3113);
/* harmony import */ var _NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11__);














function NewsHeader(param) {
    var categorySlug = param.categorySlug, categories = param.categories, withFlashMessage = param.withFlashMessage;
    var currentSite = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_SitesContextProvider__WEBPACK_IMPORTED_MODULE_5__/* .SitesContext */ .y).currentSite;
    var state = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .GlobalStateContext */ .Pn);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), mobileMenu = ref[0], setMobileMenu = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("Share News"), shareText = ref1[0], setShareText = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), timeoutId = ref2[0], setTimeoutId = ref2[1];
    var pageLink = "".concat(_constants__WEBPACK_IMPORTED_MODULE_6__/* .LIVE_SITE_URL */ .WJ).concat(router.asPath);
    (0,hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(timeoutId);
    var setMobileTitle = function(label) {
        if (!label) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileTitle),
            children: label
        });
    };
    var handleOpenMenu = function() {
        setMobileMenu(true);
    };
    var handleCloseMenu = function() {
        setMobileMenu(false);
    };
    var handleShare = function() {
        var copyLink = document.getElementById("news-share-link");
        copyLink.select();
        document.execCommand("copy");
        setShareText("Link copied");
        var timeoutId = setTimeout(function() {
            setShareText("Share News");
        }, 1000);
        setTimeoutId(timeoutId);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().container), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileMenuVisible), mobileMenu === true)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileHeader),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_BackButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().backBtn),
                        fallback: "".concat(currentSite === null || currentSite === void 0 ? void 0 : currentSite.path, "news")
                    }),
                    categorySlug === "" ? setMobileTitle("Latest") : setMobileTitle(categorySlug),
                    categories === null || categories === void 0 ? void 0 : categories.filter(function(param) {
                        var name = param.name;
                        return name === categorySlug;
                    }).map(function(param) {
                        var name = param.name;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileTitle),
                            children: name
                        }, name);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileMenuBtn),
                        onClick: handleOpenMenu,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileMenu),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileMenuItem),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                type: "button",
                                className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().shareBtn),
                                onClick: handleShare,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().mobileMenuLabel),
                                        children: shareText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        id: "news-share-link",
                                        className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().shareLink),
                                        type: "text",
                                        defaultValue: pageLink
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().closeMenuBtn),
                        onClick: handleCloseMenu
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().header),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().title),
                        title: "Explore",
                        subtitle: "Our World",
                        swapColour: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().links),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                type: "Page",
                                href: "news",
                                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().linkActive), !categorySlug && router.pathname !== "/[site]/news/archive/[page]")),
                                children: "Latest"
                            }),
                            categories === null || categories === void 0 ? void 0 : categories.map(function(param) {
                                var slug = param.slug, name = param.name;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    type: "Category",
                                    href: slug,
                                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (_NewsHeader_module_css__WEBPACK_IMPORTED_MODULE_11___default().linkActive), categorySlug === slug)),
                                    children: name
                                }, slug);
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
NewsHeader.propTypes = {
    categorySlug: (prop_types__WEBPACK_IMPORTED_MODULE_13___default().string),
    categories: (prop_types__WEBPACK_IMPORTED_MODULE_13___default().array)
};
NewsHeader.defaultProps = {
    categorySlug: "",
    categories: []
};
/* harmony default export */ __webpack_exports__["Z"] = (NewsHeader);


/***/ }),

/***/ 919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7821);
/* harmony import */ var _Pagination_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1091);
/* harmony import */ var _Pagination_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Pagination_module_css__WEBPACK_IMPORTED_MODULE_4__);







// TODO: Setup routing
function Pagination(param) {
    var pagination = param.pagination, currentPage = param.currentPage, className = param.className;
    if (!pagination || !(pagination === null || pagination === void 0 ? void 0 : pagination.hasPrevious) && !(pagination === null || pagination === void 0 ? void 0 : pagination.hasMore)) return null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    if (!pagination) return null;
    var pageNumbersShown = 6;
    var diff = currentPage % pageNumbersShown;
    var activePageNumber = diff === 1 ? 0 : diff - 1;
    if (diff === 0) activePageNumber = pageNumbersShown - 1;
    var offset = currentPage - (diff === 0 ? pageNumbersShown : diff);
    var pageTotal = Math.ceil((pagination === null || pagination === void 0 ? void 0 : pagination.total) / _constants__WEBPACK_IMPORTED_MODULE_3__/* .NEWS_POSTS_PER_PAGE */ .us);
    // todo: this could be filled from a Set or similar mechanic, filling from 1 to pageNumbersShown (+offset)
    var pageNumbers = [
        offset + 1,
        offset + 2,
        offset + 3,
        offset + 4,
        offset + 5,
        offset + 6,
        offset + 7, 
    ].filter(function(p) {
        return p <= pageTotal;
    });
    // const previousLink = (() => {
    //   let url = `/${router.query?.site}/news/`
    //   if (router.query?.categorySlug) url += router.query?.categorySlug
    //   else if (currentPage > 2) url += 'archive'
    //   if (currentPage > 2) url += `/${currentPage - 1}`
    //   return url
    // })()
    var pageLink = function(page) {
        var ref, ref1;
        var url = "/".concat((ref = router.query) === null || ref === void 0 ? void 0 : ref.site, "/news");
        return page ? "".concat(url, "/").concat(((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.categorySlug) || "archive", "/").concat(page) : url;
    };
    var handlePrevBtn = function() {
        router.push(pageLink());
    };
    var handleNextBtn = function() {
        router.push(pageLink(pageTotal - 1));
    };
    var handlePageBtn = function(page) {
        var setPage = page === 1 ? null : page;
        router.push(pageLink(setPage));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Pagination_module_css__WEBPACK_IMPORTED_MODULE_4___default().container), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Pagination_module_css__WEBPACK_IMPORTED_MODULE_4___default().btn), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Pagination_module_css__WEBPACK_IMPORTED_MODULE_4___default().btnActive), pagination === null || pagination === void 0 ? void 0 : pagination.hasPrevious)),
                onClick: handlePrevBtn
            }),
            pageNumbers.map(function(p) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Pagination_module_css__WEBPACK_IMPORTED_MODULE_4___default().page), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Pagination_module_css__WEBPACK_IMPORTED_MODULE_4___default().pageCurrent), pageNumbers[activePageNumber] === p)),
                    onClick: function() {
                        return handlePageBtn(p);
                    },
                    children: p
                }, p);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Pagination_module_css__WEBPACK_IMPORTED_MODULE_4___default().btn), (_Pagination_module_css__WEBPACK_IMPORTED_MODULE_4___default().btnFlipped), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Pagination_module_css__WEBPACK_IMPORTED_MODULE_4___default().btnActive), pagination === null || pagination === void 0 ? void 0 : pagination.hasMore)),
                onClick: handleNextBtn
            })
        ]
    });
}
Pagination.propTypes = {
    pagination: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    currentPage: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
Pagination.defaultProps = {
    pagination: {},
    currentPage: 1,
    className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 1382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Title_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8735);
/* harmony import */ var _Title_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Title_module_css__WEBPACK_IMPORTED_MODULE_2__);





function Title(param) {
    var title = param.title, subtitle = param.subtitle, swapColour = param.swapColour, lightUi = param.lightUi, borderTitle = param.borderTitle, lightSubtitle = param.lightSubtitle, className = param.className, shrinkSubtitleLength = param.shrinkSubtitleLength;
    if (!title) return null;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().container), className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().swapColour), swapColour), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().lightUi), lightUi), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().borderTitle), borderTitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().lightSubtitle), lightSubtitle), _obj)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().subtitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_Title_module_css__WEBPACK_IMPORTED_MODULE_2___default().subtitleLong), shrinkSubtitleLength && subtitle.length > shrinkSubtitleLength)),
                dangerouslySetInnerHTML: {
                    __html: subtitle
                }
            })
        ]
    });
}
Title.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    subtitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    swapColour: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    lightUi: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    borderTitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    lightSubtitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    shrinkSubtitleLength: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number)
};
Title.defaultProps = {
    title: "",
    subtitle: "",
    swapColour: false,
    lightUi: false,
    borderTitle: false,
    lightSubtitle: false,
    className: "",
    shrinkSubtitleLength: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 1610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var html_entities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9111);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7821);
/* harmony import */ var helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(406);
/* harmony import */ var _helpers_isModellinkSite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2084);








var htmlEntities = new html_entities__WEBPACK_IMPORTED_MODULE_3__/* .Html5Entities */ .JK();
function htmlDecode() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return htmlEntities.decode(string);
}
function WordpressSEO(param) {
    var url = param.url, title = param.title, seo = param.seo, image = param.image, desc = param.desc, _canonical = param.canonical, canonical = _canonical === void 0 ? null : _canonical;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var siteName;
    var fallbackTitle;
    var siteLogo;
    if ((0,_helpers_isModellinkSite__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)()) {
        siteName = "Modellink";
        fallbackTitle = "".concat(htmlDecode(title), " | ").concat(siteName);
        siteLogo = "/img/logo/modellink.jpg";
    } else {
        var ref2;
        siteName = "Select Model Management";
        fallbackTitle = "".concat(htmlDecode(title)).concat(((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.site) ? " | Select ".concat((0,helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(router.query.site)) : "", " | ").concat(siteName);
        siteLogo = "/img/logo/selectmodel.jpg";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seo && seo.title ? htmlDecode(seo.title) : fallbackTitle,
        description: (seo === null || seo === void 0 ? void 0 : seo.metaDesc) || desc || siteName,
        openGraph: {
            title: seo === null || seo === void 0 ? void 0 : seo.title,
            url: "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .LIVE_SITE_URL */ .WJ).concat(url),
            description: seo === null || seo === void 0 ? void 0 : seo.metaDesc,
            images: [
                {
                    url: image || (seo === null || seo === void 0 ? void 0 : (ref = seo.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url) || "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .LIVE_SITE_URL */ .WJ).concat(siteLogo)
                }, 
            ]
        },
        canonical: canonical
    });
}
WordpressSEO.propTypes = {
    url: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    desc: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    image: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    canonical: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    seo: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
WordpressSEO.defaultProps = {
    url: "",
    title: "",
    desc: null,
    image: "",
    seo: {},
    canonical: null
};
/* harmony default export */ __webpack_exports__["Z"] = (WordpressSEO);


/***/ }),

/***/ 1588:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * @param {Date} date
 * @param {string} locale
 * @param {} options
 *
 * @return {string}
 */ var formatDate = function(date) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        dateStyle: "medium"
    };
    // Currently, we only use the GB format, but maybe we should use something better for America? ;-)
    return date.toLocaleDateString(locale, options);
};
/* harmony default export */ __webpack_exports__["Z"] = (formatDate);


/***/ }),

/***/ 406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uppercaseFirst; }
/* harmony export */ });
function uppercaseFirst(string) {
    if (!string) return null;
    return "".concat(string.charAt(0).toUpperCase()).concat(string.substring(1));
}


/***/ }),

/***/ 662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClearTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useClearTimeout(id) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            clearTimeout(id);
        };
    }, [
        id
    ]);
}


/***/ }),

/***/ 2768:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ArticleGrid_spacing--xxxs__uBdXK","spacing--xxs":"ArticleGrid_spacing--xxs__icH34","spacing--xs":"ArticleGrid_spacing--xs__6B_2H","spacing--sm":"ArticleGrid_spacing--sm__gugLC","spacing--md":"ArticleGrid_spacing--md__hmhqf","spacing--lg":"ArticleGrid_spacing--lg__SXSim","spacing--xl":"ArticleGrid_spacing--xl__GGFq_","spacing--xxl":"ArticleGrid_spacing--xxl__gV6ZY","spacing--xxxl":"ArticleGrid_spacing--xxxl__PwT2_","container":"ArticleGrid_container__hlYbb","article":"ArticleGrid_article__j1wCd","fadeInItems":"ArticleGrid_fadeInItems__G_Hu4"};

/***/ }),

/***/ 2563:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ArticleItem_spacing--xxxs__xa_i_","spacing--xxs":"ArticleItem_spacing--xxs__j1aKD","spacing--xs":"ArticleItem_spacing--xs__gahWA","spacing--sm":"ArticleItem_spacing--sm__niBF0","spacing--md":"ArticleItem_spacing--md__7fTWy","spacing--lg":"ArticleItem_spacing--lg__TH0T8","spacing--xl":"ArticleItem_spacing--xl___d_nm","spacing--xxl":"ArticleItem_spacing--xxl__4JV_0","spacing--xxxl":"ArticleItem_spacing--xxxl__49p6G","container":"ArticleItem_container__rBeLB","link":"ArticleItem_link__9yrNB","img":"ArticleItem_img__hWh7y","title":"ArticleItem_title__z_813","subtitle":"ArticleItem_subtitle__G_v3x","created":"ArticleItem_created__K4qUY","tags":"ArticleItem_tags__dECxd","tag":"ArticleItem_tag__xKvsZ","fadeInItems":"ArticleItem_fadeInItems__VOhwt"};

/***/ }),

/***/ 6749:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"BackButton_spacing--xxxs__gjTE3","spacing--xxs":"BackButton_spacing--xxs__rSADE","spacing--xs":"BackButton_spacing--xs__8FF69","spacing--sm":"BackButton_spacing--sm___Bx45","spacing--md":"BackButton_spacing--md__AjHcV","spacing--lg":"BackButton_spacing--lg__3JElb","spacing--xl":"BackButton_spacing--xl__UL58X","spacing--xxl":"BackButton_spacing--xxl__wKmK5","spacing--xxxl":"BackButton_spacing--xxxl__HTVAR","container":"BackButton_container__8wlKy","btn":"BackButton_btn__T6gpu","fadeInItems":"BackButton_fadeInItems__MtLQK"};

/***/ }),

/***/ 4027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"CloudinaryImage_spacing--xxxs__QtiOI","spacing--xxs":"CloudinaryImage_spacing--xxs___RX_E","spacing--xs":"CloudinaryImage_spacing--xs__CjZ0m","spacing--sm":"CloudinaryImage_spacing--sm__ltlHy","spacing--md":"CloudinaryImage_spacing--md__C3K8W","spacing--lg":"CloudinaryImage_spacing--lg__8XDbe","spacing--xl":"CloudinaryImage_spacing--xl__sGgGs","spacing--xxl":"CloudinaryImage_spacing--xxl__JD0JD","spacing--xxxl":"CloudinaryImage_spacing--xxxl__j_4Vl","container":"CloudinaryImage_container__nIIa7","loaded":"CloudinaryImage_loaded__hSSNW","fadeInItems":"CloudinaryImage_fadeInItems__lFZVD"};

/***/ }),

/***/ 1130:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"CloudinaryMedia_spacing--xxxs__8hhoO","spacing--xxs":"CloudinaryMedia_spacing--xxs__jAN_O","spacing--xs":"CloudinaryMedia_spacing--xs__mCgCD","spacing--sm":"CloudinaryMedia_spacing--sm__fmlUT","spacing--md":"CloudinaryMedia_spacing--md__zi9QH","spacing--lg":"CloudinaryMedia_spacing--lg__3we4U","spacing--xl":"CloudinaryMedia_spacing--xl__5KxO2","spacing--xxl":"CloudinaryMedia_spacing--xxl__D_5z8","spacing--xxxl":"CloudinaryMedia_spacing--xxxl__wkGzl","container":"CloudinaryMedia_container__TSo9k","fadeInItems":"CloudinaryMedia_fadeInItems__9lezI"};

/***/ }),

/***/ 3725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"CloudinaryVideo_spacing--xxxs__rdnL_","spacing--xxs":"CloudinaryVideo_spacing--xxs__cmhu_","spacing--xs":"CloudinaryVideo_spacing--xs__kSj9Z","spacing--sm":"CloudinaryVideo_spacing--sm__jRoRD","spacing--md":"CloudinaryVideo_spacing--md__xPkE4","spacing--lg":"CloudinaryVideo_spacing--lg__pHjBA","spacing--xl":"CloudinaryVideo_spacing--xl__a_9qS","spacing--xxl":"CloudinaryVideo_spacing--xxl__wRN68","spacing--xxxl":"CloudinaryVideo_spacing--xxxl__mpwWX","container":"CloudinaryVideo_container__Ok78r","loaded":"CloudinaryVideo_loaded__L7h4n","mobile":"CloudinaryVideo_mobile__FsYJz","desktop":"CloudinaryVideo_desktop__4kB4o","fadeInItems":"CloudinaryVideo_fadeInItems__zGGsJ"};

/***/ }),

/***/ 1627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Layout_spacing--xxxs__8iHw7","spacing--xxs":"Layout_spacing--xxs__rg8b2","spacing--xs":"Layout_spacing--xs__dO6OG","spacing--sm":"Layout_spacing--sm__jhGe9","spacing--md":"Layout_spacing--md__vIpF7","spacing--lg":"Layout_spacing--lg__fEe2_","spacing--xl":"Layout_spacing--xl__dhV28","spacing--xxl":"Layout_spacing--xxl__K3sH1","spacing--xxxl":"Layout_spacing--xxxl__Bs9tG","main":"Layout_main__gbdP0","fadeInItems":"Layout_fadeInItems__QzPHk"};

/***/ }),

/***/ 3113:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"NewsHeader_spacing--xxxs__DRYBD","spacing--xxs":"NewsHeader_spacing--xxs__GUy5S","spacing--xs":"NewsHeader_spacing--xs__rxB1S","spacing--sm":"NewsHeader_spacing--sm__m6els","spacing--md":"NewsHeader_spacing--md__36p6V","spacing--lg":"NewsHeader_spacing--lg__HGsVC","spacing--xl":"NewsHeader_spacing--xl__Dfoof","spacing--xxl":"NewsHeader_spacing--xxl__24acn","spacing--xxxl":"NewsHeader_spacing--xxxl__dSBDz","container":"NewsHeader_container__fwavp","mobileMenuVisible":"NewsHeader_mobileMenuVisible__xgJzY","mobileMenu":"NewsHeader_mobileMenu__Tfa_b","closeMenuBtn":"NewsHeader_closeMenuBtn__9nvBe","mobileHeader":"NewsHeader_mobileHeader__TMWey","backBtn":"NewsHeader_backBtn__aMLqh","mobileTitle":"NewsHeader_mobileTitle__BiCZ_","header":"NewsHeader_header__Pdrs6","title":"NewsHeader_title__unLmX","links":"NewsHeader_links__gCd2n","link":"NewsHeader_link__mSZyW","linkActive":"NewsHeader_linkActive__ZoqRM","mobileMenuBtn":"NewsHeader_mobileMenuBtn__tu5yu","mobileMenuLabel":"NewsHeader_mobileMenuLabel__qQoMY","mobileMenuItem":"NewsHeader_mobileMenuItem__qIEUC","shareBtn":"NewsHeader_shareBtn__O8prx","shareLink":"NewsHeader_shareLink__u1_T6","fadeInItems":"NewsHeader_fadeInItems__N5LOA"};

/***/ }),

/***/ 5193:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"OutdatedBrowser_spacing--xxxs__Accab","spacing--xxs":"OutdatedBrowser_spacing--xxs__i92K8","spacing--xs":"OutdatedBrowser_spacing--xs__zWpQI","spacing--sm":"OutdatedBrowser_spacing--sm__Vrmq_","spacing--md":"OutdatedBrowser_spacing--md__vcPS_","spacing--lg":"OutdatedBrowser_spacing--lg__SYnnw","spacing--xl":"OutdatedBrowser_spacing--xl__Mc5r2","spacing--xxl":"OutdatedBrowser_spacing--xxl___59QJ","spacing--xxxl":"OutdatedBrowser_spacing--xxxl__S_A_A","container":"OutdatedBrowser_container__5_uvZ","title":"OutdatedBrowser_title___0088","text":"OutdatedBrowser_text__aSnM3","link":"OutdatedBrowser_link__HM2Bc","btn":"OutdatedBrowser_btn__r3Ac0","fadeInItems":"OutdatedBrowser_fadeInItems__7725t"};

/***/ }),

/***/ 1091:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Pagination_spacing--xxxs__4Hjs5","spacing--xxs":"Pagination_spacing--xxs__IoIm1","spacing--xs":"Pagination_spacing--xs__gTo3z","spacing--sm":"Pagination_spacing--sm__b5AQM","spacing--md":"Pagination_spacing--md__JmLDK","spacing--lg":"Pagination_spacing--lg__fpNvQ","spacing--xl":"Pagination_spacing--xl__eSREk","spacing--xxl":"Pagination_spacing--xxl__qkoEN","spacing--xxxl":"Pagination_spacing--xxxl__bY_4u","container":"Pagination_container__FdBHw","btn":"Pagination_btn__pW2IA","btnActive":"Pagination_btnActive__BcRw1","btnFlipped":"Pagination_btnFlipped__RP7qH","page":"Pagination_page___6v4T","pageCurrent":"Pagination_pageCurrent__tZnhY","fadeInItems":"Pagination_fadeInItems__q60oE"};

/***/ }),

/***/ 8735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Title_spacing--xxxs__sEhJq","spacing--xxs":"Title_spacing--xxs__DgJXk","spacing--xs":"Title_spacing--xs__DA8px","spacing--sm":"Title_spacing--sm__AvCBI","spacing--md":"Title_spacing--md__n1H3y","spacing--lg":"Title_spacing--lg___qrsK","spacing--xl":"Title_spacing--xl__7hIyQ","spacing--xxl":"Title_spacing--xxl__Eoec_","spacing--xxxl":"Title_spacing--xxxl__0Xl1t","container":"Title_container__5MuPN","swapColour":"Title_swapColour__Csfih","subtitle":"Title_subtitle__t4Jhl","lightUi":"Title_lightUi__owagC","borderTitle":"Title_borderTitle__opYdU","subtitleLong":"Title_subtitleLong__7K7dp","lightSubtitle":"Title_lightSubtitle__iCTJ6","fadeInItems":"Title_fadeInItems___Zi_4"};

/***/ })

}]);